// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"Pagination_paginationContainer__FQdl_","paginationLink":"Pagination_paginationLink__1dT-L","active":"Pagination_active__1R0gI"};